export default {
  "5g.message.h5.login": "Login",
  "5g.message.h5.chatRoom.hismsg": "The above is historical news",
  "5g.message.h5.chatRoom.send": "Send",
  "5g.message.h5.login.xieyi": "Agree to user privacy policy",
  "5g.message.h5.login.modal.title":
    "User registration and use of APP privacy agreement",
  "5g.message.h5.login.getCode": "Verification Code",
  "5g.message.h5.login.input.phone": "Please enter",
  "5g.message.h5.login.phone.name": "Mobile",

  "5g.message.h5.common.name.title": "5G Message assistant",
  "5g.message.h5.common.name.chatbot": "Robot name",
  "5g.message.h5.common.name.clear": "Cancel",
  "5g.message.h5.common.name.tem": "Template",
  "5g.message.h5.common.name.text": "Text",
  "5g.message.h5.common.name.addressSb": "Address",
  "5g.message.h5.common.name.img": "Picture",
  "5g.message.h5.common.name.video": "Video",
  "5g.message.h5.common.name.audio": "Audio",
  "5g.message.h5.common.name.file": "File",
  "5g.message.h5.common.name.tip": "Tips",
  "5g.message.h5.common.name.plsinput": "Please enter the content!",
  "5g.message.h5.common.name.mycoll": "My attention",
  "5g.message.h5.common.name.logout": "Log out",
  "5g.message.h5.common.name.msg": "News",
  "5g.message.h5.common.name.chatbot": "Robot",
  "5g.message.h5.common.name.my": "My",

  "5g.message.h5.components.web": "Webpage",
  "5g.message.h5.components.chat": "Chat",
  "5g.message.h5.components.searchAddress": "Search address",
  "5g.message.h5.address.select": "Please select an address!",
  "5g.message.h5.tipmsg.msg1": "Your browser does not support HTML5 Video Tags",
  "5g.message.h5.tipmsg.msg2": "File upload failed! Sending failed!",
  "5g.message.h5.tipmsg.msg3": "Failed to query service number details",
  "5g.message.h5.tipmsg.msg4": "Equipment information reported successfully!",
  "5g.message.h5.tipmsg.msg5": "Please select open map",
  "5g.message.h5.tipmsg.msg6": "This function is not supported temporarily!",
  "5g.message.h5.tipmsg.msg7": "You currently have no chat information",
  "5g.message.h5.tipmsg.msg8": "Go to the list of robots!",
  "5g.message.h5.tipmsg.msg9": "Focus on success!",
  "5g.message.h5.tipmsg.msg10": "Focus failed!",
  "5g.message.h5.tipmsg.msg11": "Cancellation succeeded!",
  "5g.message.h5.tipmsg.msg12": "Cancel failed!"
};



// WEBPACK FOOTER //
// ./src/locales/en_US/all.js